import { FeatureFlagKeyName } from '@mobi/settings'
import { useAppSelector } from '@core/Store/hooks'
import { FeatureValueType } from '@mobi/settings/featureFlags'
import { _returnFeatureValueOrDefault } from '@core/State/FeatureFlags/helpers/returnFeatureValueOrDefault'

export function useFeature<T extends FeatureFlagKeyName>(flag: T): FeatureValueType<T> {
  // useSelector on just the flag itself so consuming component only re-renders if this feature changes, not any feature
  const val = useAppSelector(x => x.features.features[flag])
  return _returnFeatureValueOrDefault(val, flag) as FeatureValueType<T>
}
